import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Course } from '../Models/course.model';
import { CartUpdateService } from '../Services/cartUpdate.service';
import { CartItemsCookieService } from '../Services/cartItemsCookie.service';
import { SnotifyService, SnotifyPosition } from 'ng-snotify';
import { MatDialog } from '@angular/material';
import { ShareDialogComponent } from '../share-dialog/share-dialog.component';

@Component({
  selector: 'app-course-details',
  templateUrl: './course-details.component.html',
  styleUrls: ['./course-details.component.css']
})
export class CourseDetailsComponent implements OnInit {

  private _course: Course;

  @Input()
  public set course(val: Course) {
    if (val !== this._course) {
      this._course = val;
      this.courseTopics = this._course.courseOutline ? this._course.courseOutline.split("NEXT") : [];
    }
  }
  public get course(): Course {
    return this._course;
  }

  courseTopics = [];

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private cartUpdateService:CartUpdateService,
    private cartItemsCookieService: CartItemsCookieService,
    private snotifyService: SnotifyService,
    public dialog: MatDialog
    ) { }

  ngOnInit() {

    //  // scroll
    //  document.querySelector('#componentTop').scrollIntoView({ behavior: 'smooth', block: 'center' });
     
    // this._route.data.subscribe(
    // ({course}) => {
    //   console.log('course: ', course);
    //   this.course = course;

    //   this.courseTopics = course.courseOutline ? course.courseOutline.split("NEXT") : [];
    // });
  }

  addItemToCart(course: Course){
    this.cartItemsCookieService.addItemIdToCartCookie(course.id);
    this.snotifyService.info(`Successfully added course: "${course.name}" to cart`, {position:SnotifyPosition.rightTop});
    this._router.navigateByUrl(`/cart-details`);
  }

  splitString(theString: string) {
    return theString? theString.split("NEXT") : [];
  }

  onShareClick() {
    const dialogRef = this.dialog.open(ShareDialogComponent, {
        width: '350px',
        data: { course: this.course }
      }
    );

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  onSeeOtherWorkshopsClick() {
    this._router.navigateByUrl('/workshops');
  }

}



// WEBPACK FOOTER //
// ./src/app/course-details/course-details.component.ts